var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.857,
    height: 16.286,
    viewBox: "0 0 14.857 16.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1748",
    "data-name": "Rectangle 1748",
    width: 14.857,
    height: 16.286,
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#16161a",
    strokeWidth: 1.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3131",
    "data-name": "Group 3131",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3130",
    "data-name": "Group 3130",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8477",
    "data-name": "Path 8477",
    d: "M6.714.2A4.91,4.91,0,0,1,10.22,1.654a4.976,4.976,0,0,1,1.445,3.315.809.809,0,0,1,0,.09,2.892,2.892,0,0,0,.715,1.967,2.819,2.819,0,0,1,.843,1.891v.531a2.738,2.738,0,0,1-.989,2.08,3.25,3.25,0,0,1-2.1.791H3.286a3.25,3.25,0,0,1-2.1-.791A2.738,2.738,0,0,1,.2,9.448V8.916a2.814,2.814,0,0,1,.843-1.891,2.894,2.894,0,0,0,.715-1.967.809.809,0,0,1,0-.09A4.976,4.976,0,0,1,3.209,1.654,4.91,4.91,0,0,1,6.714.2Zm3.356,5a3.4,3.4,0,0,0-.984-2.414,3.353,3.353,0,0,0-4.743,0A3.4,3.4,0,0,0,3.359,5.2a.809.809,0,0,1-.005.093A4.454,4.454,0,0,1,2.224,8.1a1.353,1.353,0,0,0-.424.812v.531a1.452,1.452,0,0,0,1.486,1.271h6.857a1.452,1.452,0,0,0,1.486-1.271V8.916A1.357,1.357,0,0,0,11.2,8.1,4.45,4.45,0,0,1,10.075,5.29.809.809,0,0,1,10.07,5.2Z",
    transform: "translate(-0.286 -0.286)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8478",
    "data-name": "Path 8478",
    d: "M8.314,19.1A2.537,2.537,0,0,1,5.8,16.546a.8.8,0,0,1,1.6,0,.915.915,0,1,0,1.829,0,.8.8,0,0,1,1.6,0A2.537,2.537,0,0,1,8.314,19.1Z",
    transform: "translate(-1.886 -4.727)",
    fill: "#16161a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f9e765b8af75302a42a77ff619430490.svg";
export { ForwardRef as ReactComponent };